import store from '@/store'

export default [
  {
    path: '/admin/uom-categories',
    name: 'uom-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/uom-category/index-v2.vue')
  },
  {
    path: '/admin/uom-categories/create',
    name: 'uom-category-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/uom-category/create.vue')
  },
  {
    path: '/admin/uom-categories/:id/edit',
    name: 'uom-category-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product/uom-category/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('product/uomCategory/find', to.params.id)
      next()
    }
  }
]
